export default __webpack_public_path__ + "static/media/overcast.7d61fd8f.gif";